export const adaptFranjaEtaria = (franjaEtariaData) => {
    return {
        id: franjaEtariaData?.id,
        displayName: franjaEtariaData?.descripcion,
        name: franjaEtariaData?.descripcion
    }
}

export const adaptFranjaEtariaArray = (
    franjasEtaria
) => {
    return structuredClone(franjasEtaria?.allFranjaEtaria)
        ?.map(franjaEtaria => adaptFranjaEtaria(franjaEtaria));
}